import { useEffect, useRef, useState } from 'react';

/**
 * Countdown decrescente em segundos. Dispara `onExpire` ao chegar em zero e
 * reinicia automaticamente. Reinicia também quando `seconds` muda (ex: troca
 * de intervalo de polling). `onExpire` é lido via ref, então não precisa estar
 * memoizado e nunca captura valor stale.
 */
export function useCountdown(seconds: number, onExpire: () => void): number {
  const [countdown, setCountdown] = useState(seconds);
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;

  useEffect(() => {
    setCountdown(seconds);
    const interval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          onExpireRef.current();
          return seconds;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [seconds]);

  return countdown;
}
